(function () {
    let CHINA_POPUP_PATH = '/pages/china-popup';
    let COUNTRY_CHINA = 'HK';

    
        if (window.location.pathname.indexOf(CHINA_POPUP_PATH) !== -1) {
            return;
        }

        fetch(window.location.origin + '/browsing_context_suggestions.json')
            .then(function (response) { return response.json(); })
            .then(function (data) {
                let countryHandle = data.detected_values && data.detected_values.country && data.detected_values.country.handle;
                if (countryHandle === COUNTRY_CHINA) {
                    window.location.href = CHINA_POPUP_PATH;

                }
            })
            .catch(function (error) {
                console.error('Error:', error);
            });

})();